import { map, reduce, filter, union, get, find } from 'lodash'

const PerformanceDashboardComponentMixin = {
  props: {
    active: {
      type: Boolean
    },
    selectedCustomers: {
      type: Array
    }
  },
  computed: {
    /**
     * If parent-level customers are present in the selected customers, we want to expand the parent customers into
     * their constituent child customers and merge everything together.
     */
    requestedCustomerIds () {
      return reduce(this.selectedCustomers, (result, customer) => {
        const customerIds = map(filter(this.customers, x => x.parent_id === customer.id), x => x.id)
        customerIds.push(customer.id)
        return union(result, customerIds)
      }, [])
    }
  },
  methods: {
    /**
     * Convenience method to get the customer name from an id (via the customers property on by the CurrentUser mixin)
     * @param customerId
     * @returns {any}
     */
    getCustomerName (customerId) {
      return get(find(this.customers, c => c.id === parseInt(customerId)), 'name')
    },
    /**
     * Get the displayed label corresponding to the overall fleet health that will be emitted to PerformanceDashboard for
     * displaying on the tab.
     */
    getStatusLabel (status) {
      switch (status) {
        case 'healthy':
          return this.$t('healthy')
        case 'unhealthy':
          return this.$t('unhealthy')
        case 'danger':
          return this.$t('very_unhealthy')
        case 'no_data':
          return this.$t('no_data')
      }
    },
    /**
     * Get the color associated with the overall fleet health that will be emitted to PerformanceDashboard for coloring the
     * health meter.
     * @param status
     * @returns {string}
     */
    getStatusColor (status) {
      switch (status) {
        case 'healthy':
          return '#5cb85c'
        case 'unhealthy':
          return '#f0ad4e'
        case 'danger':
          return '#d9534f'
        default:
          return 'gray'
      }
    },
    /**
     * Get the icon associated with the given status.
     * @param status
     * @returns {string}
     */
    getStatusIcon (status) {
      switch (status) {
        case 'healthy':
          return 'check'
        case 'unhealthy':
          return 'exclamation-triangle'
        case 'danger':
          return 'exclamation-triangle'
        default:
          return 'question'
      }
    }
  }
}

export default PerformanceDashboardComponentMixin
